import {
  selectDepositAmount,
  selectLockTime,
  useDappSelector,
} from "#/redux-state"
import { BITCOIN_DEPOSIT_FEE } from "#/shared/constants"

import DepositModalDivider from "./DepositModalDivider"
import DepositModalReceiptElement from "./DepositModalReceiptElement"

export default function DepositModalReceiptDetails() {
  const depositAmount = useDappSelector(selectDepositAmount)
  const lockTime = useDappSelector(selectLockTime)

  return (
    <>
      <DepositModalReceiptElement
        label="Amount"
        value={`${depositAmount} BTC`}
      />
      <DepositModalReceiptElement
        label="Fee"
        value={`-${BITCOIN_DEPOSIT_FEE} BTC`}
      />
      <DepositModalReceiptElement
        label="Lock period"
        value={`${Math.floor(lockTime.period / 4)} Months`}
      />
      <DepositModalDivider />
    </>
  )
}
